module.exports = __webpack_public_path__ + "img/FoggyAndSnowRain.7fbb286c.png";